import React from "react";
import { NavLink } from "react-router-dom";

import {
  biondRoute,
  blogRoute,
  faqRoute,
  pricingRoute
} from "constants/routes";

export const HeaderNavigation = () => (
  <nav>
    <ul className="nav">
      <li className="nav__item">
        <NavLink
          to={biondRoute}
          activeClassName="nav__link--active"
          className="nav__link"
        >
          Biond
        </NavLink>
      </li>
      <li className="nav__item">
        <NavLink
          to={pricingRoute}
          activeClassName="nav__link--active"
          className="nav__link"
        >
          Pricing
        </NavLink>
      </li>
      <li className="nav__item">
        <NavLink
          to={faqRoute}
          activeClassName="nav__link--active"
          className="nav__link"
        >
          FAQ
        </NavLink>
      </li>
      <li className="nav__item">
        <NavLink
          to={blogRoute}
          activeClassName="nav__link--active"
          className="nav__link"
        >
          Blog
        </NavLink>
      </li>
    </ul>
  </nav>
);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderNavigation.jsx